// extracted by mini-css-extract-plugin
export default {"header":"headerBeforeLogin_header__VTf-q","logo":"headerBeforeLogin_logo__ok1AP","rightGroup":"headerBeforeLogin_rightGroup__uTmKU","rightbtn":"headerBeforeLogin_rightbtn__xrd8X"};